import type { StockAvailability } from './types';

const STOCK_META: Record<StockAvailability, { label: string; dotColor: string; textColor: string }> = {
  IN_STOCK: {
    label: 'In Stock',
    dotColor: 'bg-success-500',
    textColor: 'text-success-700 dark:text-success-400',
  },
  LOW_STOCK: {
    label: 'Low Stock',
    dotColor: 'bg-warning-500',
    textColor: 'text-warning-700 dark:text-warning-400',
  },
  OUT_OF_STOCK: {
    label: 'Out of Stock',
    dotColor: 'bg-danger-500',
    textColor: 'text-danger-700 dark:text-danger-400',
  },
};

export interface StockAvailabilityBadgeProps {
  availability: StockAvailability;
}

export function StockAvailabilityBadge({ availability }: StockAvailabilityBadgeProps) {
  const meta = STOCK_META[availability] ?? STOCK_META.IN_STOCK;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${meta.textColor}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dotColor}`} />
      {meta.label}
    </span>
  );
}
